import React, { useState } from 'react';
import './ToTPage.css';
import Header from '../../components/Header/Header';
import Navbar from '../../components/Navbar/Navbar';
import Footer from '../../components/Footer/Footer';

/* ── Replace with real content when mam provides ── */
const HIGHLIGHTS = [
  { icon: (<svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M2 3h6a4 4 0 0 1 4 4v14a3 3 0 0 0-3-3H2z"/><path d="M22 3h-6a4 4 0 0 0-4 4v14a3 3 0 0 1 3-3h7z"/></svg>), title: 'Programme Duration', desc: 'Duration details will be added here once mam provides the ToT programme structure.' },
  { icon: (<svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M23 21v-2a4 4 0 0 0-3-3.87"/><path d="M16 3.13a4 4 0 0 1 0 7.75"/></svg>), title: 'Eligible Participants', desc: 'Eligibility criteria will be added here — teachers, faculty, trainers who can apply.' },
  { icon: (<svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><circle cx="12" cy="8" r="6"/><path d="M15.477 12.89L17 22l-5-3-5 3 1.523-9.11"/></svg>), title: 'Certification', desc: 'Certification details and recognition provided to ToT programme graduates.' },
  { icon: (<svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><rect x="2" y="3" width="20" height="14" rx="2"/><line x1="8" y1="21" x2="16" y2="21"/><line x1="12" y1="17" x2="12" y2="21"/></svg>), title: 'Training Format', desc: 'Online / Offline / Hybrid format details will be provided by mam.' },
];

const [showEnquiry, setShowEnquiry] = [false, () => {}];

function ToTPage() {
  const [show, setShow] = useState(false);
  const [formData, setFormData] = useState({ name: '', phone: '', email: '', institution: '', designation: '', message: '' });
  const [submitted, setSubmitted] = useState(false);

  const handleChange = (e) => setFormData({ ...formData, [e.target.name]: e.target.value });

  const handleSubmit = async () => {
    if (!formData.name || !formData.phone || !formData.email) { alert('Please fill required fields.'); return; }
    try {
      await fetch('http://localhost:5000/api/enquiry', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ formType: 'tot-enquiry', ...formData }),
      });
    } catch (e) {}
    setSubmitted(true);
  };

  return (
    <div className="tot__page">
      <Header />
      <Navbar />

      {/* Hero */}
      <div className="tot__hero">
        <div className="tot__hero-content">
          <p className="tot__eyebrow">ibots Trainer Certification</p>
          <h1 className="tot__title">Training of Trainers <span>Programme</span></h1>
          <p className="tot__sub">
            Empower educators and trainers to deliver ibots STEM curriculum. 
            Details and content for this programme will be updated shortly.
          </p>
          <button className="tot__cta-btn" onClick={() => setShow(true)}>
            Express Interest →
          </button>
        </div>
      </div>

      {/* Highlights */}
      <div className="tot__highlights">
        <h2 className="tot__section-title">Programme Overview</h2>
        <p className="tot__section-sub">Content will be updated once details are confirmed by the ibots team.</p>
        <div className="tot__highlights-grid">
          {HIGHLIGHTS.map((h, i) => (
            <div key={i} className="tot__highlight-card">
              <div className="tot__highlight-icon">{h.icon}</div>
              <h3 className="tot__highlight-title">{h.title}</h3>
              <p className="tot__highlight-desc">{h.desc}</p>
            </div>
          ))}
        </div>
      </div>

      {/* CTA Banner */}
      <div className="tot__cta-banner">
        <div>
          <h3 className="tot__banner-title">Interested in Becoming an ibots Trainer?</h3>
          <p className="tot__banner-sub">Register your interest and our team will reach out with full programme details once available.</p>
        </div>
        <button className="tot__banner-btn" onClick={() => setShow(true)}>Register Interest →</button>
      </div>

      {/* Enquiry Form Popup */}
      {show && (
        <div className="tot__overlay" onClick={() => setShow(false)}>
          <div className="tot__form-box" onClick={e => e.stopPropagation()}>
            <button className="tot__form-close" onClick={() => setShow(false)}>✕</button>
            {submitted ? (
              <div className="tot__success">
                <div className="tot__success-icon">✓</div>
                <h3>Interest Registered!</h3>
                <p>Our team will contact you with full ToT programme details once available.</p>
                <button className="tot__submit-btn" onClick={() => setShow(false)}>Close</button>
              </div>
            ) : (
              <>
                <h2 className="tot__form-title">Training of Trainers — Register Interest</h2>
                <p className="tot__form-sub">Fill in your details and we will reach out with full programme information.</p>
                <div className="tot__form">
                  <div className="tot__form-row">
                    <div className="tot__form-group"><label>Full Name *</label><input name="name" value={formData.name} onChange={handleChange} placeholder="Your full name" className="tot__input" /></div>
                    <div className="tot__form-group"><label>Phone *</label><input name="phone" value={formData.phone} onChange={handleChange} placeholder="+91 XXXXX XXXXX" className="tot__input" /></div>
                  </div>
                  <div className="tot__form-row">
                    <div className="tot__form-group"><label>Email *</label><input name="email" value={formData.email} onChange={handleChange} placeholder="you@example.com" className="tot__input" /></div>
                    <div className="tot__form-group"><label>Institution</label><input name="institution" value={formData.institution} onChange={handleChange} placeholder="School / College name" className="tot__input" /></div>
                  </div>
                  <div className="tot__form-group tot__form-group--full"><label>Designation</label><input name="designation" value={formData.designation} onChange={handleChange} placeholder="e.g. Teacher, HOD, Trainer" className="tot__input" /></div>
                  <div className="tot__form-group tot__form-group--full"><label>Message (optional)</label><textarea name="message" value={formData.message} onChange={handleChange} placeholder="Any questions or context..." className="tot__input" rows={3} /></div>
                  <button className="tot__submit-btn" onClick={handleSubmit}>Submit Interest →</button>
                </div>
              </>
            )}
          </div>
        </div>
      )}

      <Footer />
    </div>
  );
}

export default ToTPage;
